import { OnInit, Component, ViewChild, ElementRef, PACKAGE_ROOT_URL } from '@angular/core';

import { ITagEntity } from '../../interfaces/tag-entity';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import { TaggingService } from '../../services';

@Component({
  selector: 'tagging-admin',
  templateUrl: './tagging-admin.component.html',
  styleUrls: ['./tagging-admin.component.css'],
})
export class TaggingAdminComponent implements OnInit {
  public tags: ITagEntity[];
  public tagName: string;
  public tagDescription: string;

  // if this is not null then it is the tag currently being edited
  public editedTag: ITagEntity = null;

  // the tag to delete upon user confirmation
  public deletedTag: ITagEntity = null;
  public showDeleteTagDialog: boolean = false;

  constructor(private taggingService: TaggingService, private messageService: MessageService) {}

  ngOnInit() {
    this.load();
  }

  load() {
    this.taggingService.getAllTags().subscribe(
      (tags) => {
        this.tags = tags;
      },
      (error) => {
        // todo: use message service to show error
        this.messageService.add(Message.Error('An error occurred loading Tags'));
      },
    );
  }

  addTag() {
    // if the tag name exists an error will be returned.
    this.taggingService.createTag({ name: this.tagName, description: this.tagDescription }).then(
      () => {
        // clear input and reload page
        this.clearAndReload();
      },
      (error) => {
        console.log('ERROR: ', error);
        this.messageService.add(Message.Error(error.error.Message));
      },
    );
  }

  editTag(tag: ITagEntity) {
    // if tag is currently being edited, unset the edit flag
    if (this.editedTag == tag) {
      this.clearAndReload();
      return;
    }

    this.editedTag = tag;

    this.tagName = tag.name;
    this.tagDescription = tag.description;
  }

  updateTag() {
    this.editedTag.name = this.tagName;
    this.editedTag.description = this.tagDescription;

    this.taggingService.editTag(this.editedTag).then(() => {
      // clear input and reload page
      this.clearAndReload();
    });
  }

  clearAndReload() {
    this.tagName = '';
    this.tagDescription = '';
    this.editedTag = null;
    this.deletedTag = null;

    this.load();
  }

  deleteTag(tag) {
    this.deletedTag = tag;

    // ensure user wishes to delete the tag
    this.showDeleteTagDialog = true;
  }

  acceptDeleteTag() {
    // if the tag is in use an error will be returned
    let id = this.deletedTag.id;

    this.taggingService.deleteTag(id).then(
      () => {
        this.messageService.add(Message.Success('Tag successfully deleted'));
        this.showDeleteTagDialog = false;
        this.clearAndReload();
      },
      (error) => {
        this.messageService.add(Message.Error(error.error.Message));
      },
    );
  }

  alterActiveState(tag: ITagEntity) {
    if (tag.inactiveDate == null) {
      this.taggingService.deactivateTag(tag.id).then(() => {
        this.load();
      });
    } else {
      this.taggingService.activateTag(tag.id).then(() => {
        this.load();
      });
    }
  }

  cancelDeleteTag() {
    this.showDeleteTagDialog = false;
    this.deletedTag = null;
  }
}
